import {
  runRateTypeSchema,
  scrapYieldTypeSchema,
} from '@snap-types/models/enums';
import {
  visualRunRateTypeToRunRateType,
  visualScrapYieldTypeToScrapYieldType,
} from '@snap-types/models/visual/operation/enums';
import { VisualOperationTypeConfiguratorRecord } from '@snap-types/models/visual/operation-type';
import { z } from 'zod/v4';

export const snapConfiguratorOperationTypeMetaSchema = z.object({
  id: z.string(),
  description: z.string().nullable(),
  resourceId: z.string().nullable(),
  setupHrs: z.number().nullable(),
  setupCostPerHr: z.number().nullable(),
  run: z.number().nullable(),
  runType: runRateTypeSchema.nullable(),
  runCostPerHr: z.number().nullable(),
  runCostPerUnit: z.number().nullable(),
  burPerHrRun: z.number().nullable(),
  burPerHrSetup: z.number().nullable(),
  burPerOperation: z.number().nullable(),
  burPerUnitRun: z.number().nullable(),
  burPercentRun: z.number().nullable(),
  burPercentSetup: z.number().nullable(),
  scrapYieldType: scrapYieldTypeSchema.nullable(),
  scrapYieldPct: z.number().nullable(),
  fixedScrapUnits: z.number().nullable(),
});
export type ConfiguratorOperationTypeOptionMeta = z.infer<
  typeof snapConfiguratorOperationTypeMetaSchema
>;

export const snapConfiguratorOperationTypeSchema = z.object({
  label: z.string(),
  value: z.string(),
  meta: snapConfiguratorOperationTypeMetaSchema,
});

export type SnapConfiguratorOperationType = z.infer<
  typeof snapConfiguratorOperationTypeSchema
>;

export const mapVisualToSnapshotOperationType = (
  operationType: VisualOperationTypeConfiguratorRecord,
) => {
  return {
    label: operationType.id,
    value: operationType.id,
    meta: {
      id: operationType.id,
      description: operationType.description,
      resourceId: operationType.resource_id,
      setupHrs: operationType.setup_hrs,
      setupCostPerHr: operationType.setup_cost_per_hr,
      run: operationType.run,
      runType: operationType.run_type
        ? visualRunRateTypeToRunRateType[operationType.run_type]
        : null,
      runCostPerHr: operationType.run_cost_per_hr,
      runCostPerUnit: operationType.run_cost_per_unit,
      burPerHrRun: operationType.bur_per_hr_run,
      burPerHrSetup: operationType.bur_per_hr_setup,
      burPerOperation: operationType.bur_per_operation,
      burPerUnitRun: operationType.bur_per_unit_run,
      burPercentRun: operationType.bur_percent_run,
      burPercentSetup: operationType.bur_percent_setup,
      scrapYieldType: operationType.scrap_yield_type
        ? visualScrapYieldTypeToScrapYieldType[operationType.scrap_yield_type]
        : null,
      scrapYieldPct: operationType.scrap_yield_pct,
      fixedScrapUnits: operationType.fixed_scrap_units,
    },
  };
};

export type SnapshotOperationType = ReturnType<
  typeof mapVisualToSnapshotOperationType
>;

export function isProperOperationTypeRecord(
  operationType: unknown,
): operationType is SnapshotOperationType {
  return snapConfiguratorOperationTypeSchema.safeParse(operationType).success;
}
